module.exports = __webpack_public_path__ + "assets/img/1221587028382_.pic_hd.fa358723.jpg";